import { ArrowLeft } from 'lucide-react'
import { Link } from 'react-router'
import { Button } from '@shared/components/ui/button'

interface NotFoundStateProps {
  message: string
  backTo: string
  backLabel?: string
}

export function NotFoundState({
  message,
  backTo,
  backLabel = 'Voltar',
}: NotFoundStateProps) {
  return (
    <div className="flex min-h-96 items-center justify-center">
      <div className="text-center">
        <p className="text-red-600 dark:text-red-300">{message}</p>
        <Button variant="outline" className="mt-4" asChild>
          <Link to={backTo}>
            <ArrowLeft className="size-4" />
            {backLabel}
          </Link>
        </Button>
      </div>
    </div>
  )
}

NotFoundState.displayName = 'NotFoundState'
